import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import "./style/dark.scss";
import { useContext } from "react";
import {
  DarkModeContext,
  DarkModeContextProvider,
} from "./context/darkModeContext";

import { ToastContainer } from "react-toastify";
import UserList from "./pages/employees/UserList";
import EditEmployee from "./pages/employees/EditEmployee";
import MyProfile from "./pages/profile/MyProfile";
import PrivateRoute from "./router/PrivateRoute";
import PasswordResetForm from "./pages/reset/PasswordReset";
import UpdateProfile from "./pages/profile/UpdateProfile";
import ChangePassword from "./pages/profile/ChangePassword";
import ActivityListTable from "./pages/activity/ActivityListTable";
import Settings from "./pages/settings/Settings";
import InventoryAlert from "./pages/inventory/InventoryAlert";

import AddEmployee from "./pages/employees/AddEmployee";
import ViewEmployee from "./pages/employees/ViewEmployee";

import InventoryDashboard from "./pages/inventory/InventoryDashboard";
import InventoryProduct from "./pages/inventory/InventoryProduct";
import InventoryProductAdd from "./pages/inventory/InventoryProductAdd";
import InventoryProductUpdate from "./pages/inventory/InventoryProductUpdate";

import DashboardManageJobs from "./pages/managejobs/DashboardManageJobs";
import JobSheetAdd from "./pages/managejobs/JobSheetAdd";
import JobSheetView from "./pages/managejobs/JobSheetView";
import JobSheetEdit from "./pages/managejobs/JobSheetEdit";

import RenameStockCodeToMpn from "./pages/inventory/RenameStockCodeToMpn";
import OrderListing from "./pages/orders/OrderListing";
import B2BRoute from "./router/B2BRoute";
import B2BDashboard from "./pages/b2b/B2BDashboard";
import B2BWholesaleOrder from "./pages/b2b/B2BWholesaleOrder";

/**
 * 
  SUPER_ADMIN / ADMIN / MANAGER
  → normal application access

  FITTER, DISTRIBUTOR
  → /managejobs
  → /managejobs/view/:jobId

  FITTER, DISTRIBUTOR
  → /  → redirected to /managejobs

  FITTER, DISTRIBUTOR
  → /inventory → redirected to /managejobs
 * 
 */
function App() {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset" element={<PasswordResetForm />} />
          <Route path="/unauthorized" element={<div>Access Denied</div>} />

          {/* Manage Jobs: all authenticated employees including FITTER, DISTRIBUTOR */}
          <Route element={<PrivateRoute />}>
            <Route path="/managejobs" element={<DashboardManageJobs />} />
            <Route path="/managejobs/view/:jobId" element={<JobSheetView />} />
            <Route
              path="/managejobs/barcode/:barcode"
              element={<JobSheetView />}
            />
          </Route>

          {/* Manager + job creation */}
          <Route
            element={
              <PrivateRoute
                allowedRoles={["SUPER_ADMIN", "ADMIN", "MANAGER", "DISTRIBUTOR"]}
                redirectTo="/managejobs"
              />
            }
          >
            {/* add or edit job needs admin */}
            <Route path="/managejobs/add" element={<JobSheetAdd />} />
            <Route path="/managejobs/edit/:jobId" element={<JobSheetEdit />} />
          </Route>

          {/* admin-only routes, NOT ACCESS TO FITTER and DISTRIBUTOR */}
          <Route
            element={
              <PrivateRoute
                blockedRoles={["FITTER", "DISTRIBUTOR"]}
                redirectTo="/unauthorized"
              />
            }
          >
            <Route path="/" element={<Home />} />

            <Route path="/employees" element={<UserList />} />
            <Route path="/employees/view/:id" element={<ViewEmployee />} />
            <Route path="/employees/new" element={<AddEmployee />} />
            <Route path="/employees/update/:id" element={<EditEmployee />} />

            <Route path="/inventory" element={<InventoryDashboard />} />
            <Route
              path="/inventory/view/:productId"
              element={<InventoryProduct />}
            />
            <Route path="/inventory/new" element={<InventoryProductAdd />} />
            <Route
              path="/inventory/update/:productId"
              element={<InventoryProductUpdate />}
            />

            <Route path="/my-profile" element={<MyProfile />} />
            <Route path="/profile/update" element={<UpdateProfile />} />
            <Route path="/profile/change" element={<ChangePassword />} />
            <Route path="/logs" element={<ActivityListTable />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/inventory-alert" element={<InventoryAlert />} />

            <Route path="/rename" element={<RenameStockCodeToMpn />} />
            <Route path="/orders" element={<OrderListing />} />
          </Route>

          {/* b2b only routes */}
          <Route element={<B2BRoute />}>
            <Route path="/b2b" element={<B2BDashboard />} />
            <Route path="/b2bwholesaleorder" element={<B2BWholesaleOrder />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

// export default App;
export default () => (
  <DarkModeContextProvider>
    <App />
  </DarkModeContextProvider>
);
